module.exports = __webpack_public_path__ + "static/media/1POLICY16.d49a8d65.jpg";